import SelectTruckingCompany from './SelectTruckingCompany';

export default SelectTruckingCompany;
